export default __webpack_public_path__ + "assets/6c0d763397ff9c7e6d20cceb5c369527.svg";